import { styled } from "@mui/material/styles";
import Chip from '@mui/material/Chip';

export const ContainerGroup = styled('div')(({ alignStart }) => {
  return {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: alignStart ? 'flex-start' : 'center',
    flexDirection: 'row',
    gap: '0.75rem'
  }
})

export const StyledChip = styled(Chip)(({ isSpecial, isError, isInvalid }) => {
  return {
    backgroundColor: isInvalid === true ? "#FFE08A" : (isError ? "#ffe3e3" : (isSpecial ? "#cefadc" : "#f3f3f3")),
    color: isInvalid === true ? "#7A5200" : (isError ? "#af4545" : (isSpecial ? "#66ae87" : "#555555")),
    fontWeight: "bold",
    height: "auto",
    minHeight: "24px",
    fontSize: "12px",
    marginRight: "4px",
    maxWidth: "180px", // max width applied so ellipsis gets triggered
    ".MuiChip-label": {
      padding: "2px 8px",
      display: "flex",
      alignItems: "center",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    ".MuiChip-icon": {
      color: "inherit",
      marginLeft: "8px",
      flexShrink: 0
    }
  };
});

export const CustomIconArea = styled("div")(() => {
  return {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "transparent",
    border: "1px solid #e9e9e9",
    borderRadius: "8px",
    color: "#4a4a4a",
    padding: "2px 6px",
    fontSize: "11px",
    fontWeight: "bold",
    height: "24px",
    marginLeft: "2px",
    cursor: "default",
    whiteSpace: "nowrap"
  };
});

export const TooltipContentContainer = styled('div')(() => {
  return {
    display: 'flex', 
    flexDirection: 'column', 
    gap: '4px',
    maxHeight: '200px',
    overflowY: 'auto',
    paddingRight: '6px',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.5)',
      },
    },
  };
});
